module.exports = __webpack_public_path__ + "static/img/Belt Buckle 2-3.d541ca6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Belt Buckle 2-3.jpg
// module id = CNhn
// module chunks = 1